import { pathOr } from 'ramda';
import { IPhotoSchema } from 'shared/types/carousel';

import { IState } from '../../store';

export const getLayout = (state: IState): IPhotoSchema | null => {
  const photos = pathOr([] as IPhotoSchema[], ['offerData', 'offer', 'photos'], state);
  const layout = photos.find(photo => photo.isLayout);

  return layout || null;
};
